var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,14a9,9,0,1,0,9-9A9.01,9.01,0,0,0,3,14Zm9-7a7,7,0,1,1-7,7A7.008,7.008,0,0,1,12,7Zm-1,7V9.2a1,1,0,0,1,2,0V13h3a1,1,0,0,1,0,2H12A1,1,0,0,1,11,14ZM8,3A1,1,0,0,1,8,1h8a1,1,0,0,1,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.ad42675901156a27e850d94cf8a39ab9.svg";
export { ForwardRef as ReactComponent };